import React from 'react'
import { Link, useParams } from 'react-router-dom';
import { TextSM } from '../../../../Components/Text/NormalText';
import ViewMore from './ViewMore';
import Pagination from '../../../../Components/Utils/Pagenation';
import TConditionCard from './TConditionCard';

function MobileTConditionIndex({data,getData,total,pageIndex,setPageIndex,dataCount,setDataCount}) {
    return (
      <div className=' w-full h-[calc(100vh-160px)]'>
         <div className=' w-full h-[calc(100vh-192px)] overflow-y-auto py-1 px-2'>
          {
              data && data.map((item,index)=>{
                  return(
                      <TConditionCard item={item} key={index} getData={getData}/>
                  )
              })
          }
          </div> 
         <div className=' w-full h-8'>
                  <Pagination
                    total={total}
                    pageIndex={pageIndex}
                    setPageIndex={setPageIndex}
                    dataCount={dataCount}
                    setDataCount={setDataCount}
                  />
          </div> 
      </div>
    )
  }
export default MobileTConditionIndex